export function SortNew(jobType) {
    return {
        type: 'job/jobSort/SORT_NEW',
        payload: jobType,
    };
}

export function SortOld(jobType) {
    return {
        type: 'job/jobSort/SORT_OLD',
        payload: jobType,
    };
}

export function SortAtoZ(jobType) {
    return {
        type: 'job/jobSort/SORT_AZ',
        payload: jobType,
    };
}

export function newSearch(term, jobType) {
    return {
        type: 'job/new/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function fullSearch(term, jobType) {
    return {
        type: 'job/full/SEARCH',
        term: term,
        jobType: jobType,
    };
}

export function completeSearch(term, jobType) {
    return {
        type: 'job/complete/SEARCH',
        term: term,
        jobType: jobType,
    };
}